import { iso8601ToDate } from "@/utils/iso8601ToDate";

export interface UserSubscriptionDto {
  endDate: {
    __type: "Date";
    iso: string;
  };
  startDate: {
    __type: "Date";
    iso: string;
  };
  resumeDate: {
    __type: "Date";
    iso: string;
  };
}

export const mapUserSubscriptionDtoToDomain = (dto: UserSubscriptionDto): UserSubscriptionDomain => {
    return {
        endDate: iso8601ToDate(dto.endDate.iso),
        startDate: iso8601ToDate(dto.startDate.iso),
        resumeDate: iso8601ToDate(dto.resumeDate.iso),
        isSubscribed: dto.endDate.iso > new Date().toISOString(),
    }
}

export interface UserSubscriptionDomain {
  endDate: Date | null;
  startDate: Date | null;
  resumeDate: Date | null;
  isSubscribed: boolean;
}
